module.exports = __webpack_public_path__ + "img/mishmesh_no.f7b38bf1.png";